import React from "react";
import { CardHeader } from "@material-ui/core";
import { TFunctionResult } from "i18next";

interface LoginFormHeader {
  title: string | TFunctionResult;
}

const LoginFormHeader: React.FC<LoginFormHeader> = ({ title }) => {
  return (
    <CardHeader
      data-testid="signInTitle"
      titleTypographyProps={{
        align: "center",
        gutterBottom: false,
        paragraph: false,
        variant: "h1",
      }}
      title={title}
    />
  );
};

export default LoginFormHeader;
